export const Turoa = 'turoa';
export const Waipori = 'waipori';
export const Aio = 'aio';
export const Futura = 'futura';
export const Maku = 'maku';
export const Minimalist = 'minimalist';
export const Kiri = 'kiri';
export const Rua = 'rua';
export const Aurajet = 'aurajet-technology';
export const Satinjet = 'satinjet-technology';
export const VJet = 'vjet-technology';
export const Airstream = 'airstream-technology';

/**
 * The collection slugs whose page carries a "you might also like" row (the `products/slider` tastic).
 * On those pages the row deliberately shows everything OUTSIDE the collection being viewed, which is
 * why the slugs have to be listed: they are the ones with a matching `searchableAttributes.range`.
 */
export const COLLECTION_SLUGS = [Turoa, Waipori, Aio, Futura, Maku, Minimalist, Kiri, Rua];

export const PRODUCT_RANGES = [
      'Opal',
      'Tūroa',
      'Waipori',
      'Aio',
      'Futura',
      'Maku',
      'Minimalist',
      'Kiri',
      'Rua',
  ]; 